// extracted by mini-css-extract-plugin
module.exports = {"cont":"_93444fe79c--cont--38cdb","description":"_93444fe79c--description--3Ykcb"};